module.exports = __webpack_public_path__ + "img/xqxh6.8af6926b.png";